export default "__VITE_ASSET__CiiD19KB__"